import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import Login from "./Login";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Dashboard = React.lazy(() => import('./Dashboard'));
const UberAccount = React.lazy(() => import('./UberAccount'));

const DashboardHome = React.lazy(() => import('./pages/DashboardHome'));
const DashboardAdmin = React.lazy(() => import('./pages/DashboardAdmin'));
const DashboardEmail = React.lazy(() => import('./pages/DashboardEmail'));
const DashboardDevice = React.lazy(() => import('./pages/DashboardDevice'));
const DashboardUber = React.lazy(() => import('./pages/DashboardUber'));
const DashboardDatabase = React.lazy(() => import('./pages/DashboardDatabase'));
const DashboardUserView = React.lazy(() => import('./pages/DashboardUserView'));

const devToolsWarning = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
if (typeof devToolsWarning === 'object') {
    devToolsWarning.inject = function() {};
}

if (process.env.NODE_ENV === 'production') {
  console.warn = () => {};
}

const uberAccounts = new Set(['uber', 'shing', 'ray', 'fei', 'althea']);

const getUserIdentity = (user) => String(user?.account || user?.username || user?.name || '').toLowerCase();

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && userStr) {
    try {
      const user = JSON.parse(userStr);
      if (uberAccounts.has(getUserIdentity(user))) {
        return <Navigate to="/uber-account" replace />;
      }
    } catch (e) {}
  }

  return children;
};

const UberRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (!uberAccounts.has(getUserIdentity(user))) {
        return <Navigate to="/dashboard" replace />;
      }
    } catch (e) {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#000000',color:'#94a3b8',fontSize:'1.1rem'}}>載入中...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />

          <Route path="/dashboard" element={
            <ProtectedRoute requireAdmin={true}>
              <Dashboard />
            </ProtectedRoute>
          }>
            <Route index element={<DashboardHome />} />
            <Route path="admin" element={<DashboardAdmin />} />
            <Route path="email" element={<DashboardEmail />} />
            <Route path="device" element={<DashboardDevice />} />
            <Route path="uber" element={<DashboardUber />} />
            <Route path="database" element={<DashboardDatabase />} />
            <Route path="user" element={<DashboardUserView />} />
          </Route>

          <Route path="/uber-account" element={
            <UberRoute>
              <UberAccount />
            </UberRoute>
          } />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
